import User from 'lib/user';
import GA from 'lib/ga';
import rootStore from 'reducers';
import { getItemsCount } from './itemsCount'
import { getLastItemPreDelivered } from './user'
import { EXPERTS_ROUTES } from '../helpers/ApplicationHelper'

export const SESSION = Symbol('SESSION');

export function session(userData = null) {
    let Session = rootStore.getState().Session;
    let user = new User(userData);

    if((!Session || (Session && !Session.isLoggedIn)) && user.isLoggedIn()){
        GA.userLoggedIn(user.lead_id);
        rootStore.dispatch(getItemsCount(user.id))
        if(EXPERTS_ROUTES.some(route => location.href.includes(route))){
            rootStore.dispatch(getLastItemPreDelivered(user.id))
        }
    }

    return {
        type:       SESSION,
        payload:    {
            isLoggedIn: user.isLoggedIn(),
            userData: user
        }
    }
}

// export function facebookSession(userData = null) {
//     let Session = rootStore.getState().Session;
//     let user = new User(null, userData);
//
//     if((!Session || (Session && !Session.isLoggedIn)) && user.isLoggedIn()){
//         GA.userLoggedIn(user.lead_id);
//     }
//
//     return {
//         type:       SESSION,
//         payload:    {
//             isLoggedIn: user !== null,
//             userData: user
//         }
//     }
// }